import { Routes } from '@angular/router';
import { AuthGuard } from '@infodocs/shared/guards/auth.guard';
import {
	PublicPagesWrapperComponent
} from '@infodocs/shared/components/public-pages-wrapper/public-pages-wrapper.component';

export const trustRoutes: Routes = [
	{
		path: '',
		canActivate: [AuthGuard],
		loadComponent: () => import('@infodocs/shared/components/private-pages-wrapper/private-pages-wrapper.component')
			.then(m => m.PrivatePagesWrapperComponent),
		children: [
			{
				path: '',
				pathMatch: 'full',
				redirectTo: '/portfolio/trust',
			},

			{
				path: 'profile/:trustId',
				redirectTo: ':trustId',
			},
			{
				path: ':trustId',
				loadComponent: () => import('./pages/dashboard-page/dashboard-page.component').then(m => m.DashboardPageComponent),
				children: [
					{
						path: '',
						pathMatch: 'full',
						loadComponent: () => import('./pages/dashboard-page/dashboard-tab/dashboard-tab.component').then(m => m.DashboardTabComponent),
					},
					{
						path: 'trust',
						loadComponent: () => import('./pages/dashboard-page/trust-tab/trust-tab.component').then(m => m.TrustTabComponent),
						children: [
							{
								path: '',
								pathMatch: 'full',
								redirectTo: 'information',
							},
							{
								path: 'information',
								loadComponent: () => import('./pages/dashboard-page/trust-tab/trust-information-tab/trust-information-tab.component').then(m => m.TrustInformationTabComponent),
							},
							{
								path: 'admin',
								loadComponent: () => import('./pages/dashboard-page/trust-tab/trust-admin-tab/trust-admin-tab.component').then(m => m.TrustAdminTabComponent),
							},
							{
								path: 'dates',
								loadComponent: () => import('./pages/dashboard-page/trust-tab/diary-dates-tab/diary-dates-tab/diary-dates-tab.component').then(m => m.DiaryDatesTabComponent),
							},
							{
								path: 'details',
								loadComponent: () => import('./pages/dashboard-page/trust-tab/trust-details-tab/contact-details-tab/contact-details-tab.component').then(m => m.ContactDetailsTabComponent),
							},
							{
								path: 'access',
								loadComponent: () => import('./pages/dashboard-page/trust-tab/trust-access-tab/trust-access-tab.component').then(m => m.TrustAccessTabComponent),
							},
							{
								path: 'founder',
								loadComponent: () => import('./pages/dashboard-page/trust-tab/trust-founder-tab/trust-founder-tab.component'),
							}
						],
					},
					{
						path: 'trustees',
						loadComponent: () => import('./pages/dashboard-page/trustees-tab/trustees-tab.component').then(m => m.TrusteesTabComponent),
						children: [
							{
								path: '',
								pathMatch: 'full',
								redirectTo: 'list',
							},
							{
								path: 'list',
								loadComponent: () => import('./pages/dashboard-page/trustees-tab/trustees-list-tab/trustees-list-tab.component').then(m => m.TrusteesListTabComponent),
							},
							{
								path: ':trusteeId',
								loadComponent: () => import('./pages/dashboard-page/trustees-tab/trustee-tab/trustee-tab.component').then(m => m.TrusteeTabComponent),
								children: [
									{
										path: '',
										pathMatch: 'full',
										redirectTo: 'information',
									},
									{
										path: 'information',
										loadComponent: () => import('./pages/dashboard-page/trustees-tab/trustee-tab/trustee-information-tab/trustee-information-tab.component').then(m => m.TrusteeInformationTabComponent),
									},
									{
										path: 'appointments',
										loadComponent: () => import('./pages/dashboard-page/trustees-tab/trustee-tab/trustee-appointments-tab/trustee-appointments-tab.component').then(m => m.TrusteeAppointmentsTabComponent),
									},
									{
										path: 'beneficial-interests',
										loadComponent: () => import('./pages/dashboard-page/trustees-tab/trustee-tab/trustee-beneficial-interests-tab/trustee-beneficial-interests-tab.component').then(m => m.TrusteeBeneficialInterestsTabComponent),
									},
									{
										path: 'details',
										loadComponent: () => import('./pages/dashboard-page/trustees-tab/trustee-tab/trustee-details-tab/trustee-details-tab.component').then(m => m.TrusteeDetailsTabComponent),
									},
								],
							},
						],
					},
					{
						path: 'beneficiaries',
						loadComponent: () => import('./pages/dashboard-page/beneficiaries-tab/beneficiaries-tab/beneficiaries-tab.component').then(m => m.BeneficiariesTabComponent),
						children: [
							{
								path: '',
								pathMatch: 'full',
								redirectTo: 'list',
							},
							{
								path: 'list',
								loadComponent: () => import('./pages/dashboard-page/beneficiaries-tab/beneficiaries-list-tab/beneficiaries-list-tab.component').then(m => m.BeneficiariesListTabComponent),
							},
							{
								path: ':beneficiaryId',
								loadComponent: () => import('./pages/dashboard-page/beneficiaries-tab/beneficiary-tab/beneficiary-tab.component').then(m => m.BeneficiaryTabComponent),
								children: [
									{
										path: '',
										pathMatch: 'full',
										redirectTo: 'information',
									},
									{
										path: 'information',
										loadComponent: () => import('./pages/dashboard-page/beneficiaries-tab/beneficiary-tab/beneficiary-information-tab/beneficiary-information-tab.component').then(m => m.BeneficiaryInformationTabComponent),
									},
									{
										path: 'appointments',
										loadComponent: () => import('./pages/dashboard-page/beneficiaries-tab/beneficiary-tab/beneficiary-appointments-tab/beneficiary-appointments-tab.component').then(m => m.BeneficiaryAppointmentsTabComponent),
									},
									{
										path: 'beneficial-interests',
										loadComponent: () => import('./pages/dashboard-page/beneficiaries-tab/beneficiary-tab/beneficiary-beneficial-interests-tab/beneficiary-beneficial-interests-tab.component').then(m => m.BeneficiaryBeneficialInterestsTabComponent),
									},
									{
										path: 'details',
										loadComponent: () => import('./pages/dashboard-page/beneficiaries-tab/beneficiary-tab/beneficiary-details-tab/beneficiary-details-tab.component').then(m => m.BeneficiaryDetailsTabComponent),
									},
								],
							},
						],
					},
					{
						path: 'documents',
						loadComponent: () => import('./pages/dashboard-page/documents-tab/documents-tab.component'),
						children: [
							{
								path: '',
								loadComponent: () => import('./pages/dashboard-page/documents-tab/documents-list-tab/documents-list-tab.component')
							}
						]
					}
				],
			},
		],
	},

	{
		path: '**',
		component: PublicPagesWrapperComponent,
		children: [
			{
				path: '**',
				loadComponent: () => import('../public/pages/error-page/error-page.component').then(m => m.ErrorPageComponent),
				data: { headerType: 'withLogin' },
			},
		],
	},
];
